export default {
  name: 'Name',
  selectGroups: 'Group selection',
  group: 'Group'
}
